module.exports = __webpack_public_path__ + "static/media/bullet-arrow.9c8e5eb5.svg";